import { BaseTag }   from "mixs/base/base_mixin";
import watch from "redux-watch";
import isEqual from 'is-equal';
class DeliveredTotal extends BaseTag {
  init(){
    super.init();
    this.watch();
  }
  isShowTotalBefore(){
    if(this.opts.total_before > 0){ return true; }
    if(this.isShowStringsBefore()){ return false; }
    return true;
  }
  isShowDeliveredAndBefore(){
    if(!this.isShowTotalBefore()){ return false; }
    if(this.isShowStringsBefore()){ return true; }
    return false;
  }
  isShowStringsBefore(){
    return this.opts.strings_before.length > 0
  }

  isShowTotal(){
    if(this.opts.total > 0){ return true; }
    if(this.isShowStrings()){ return false; }
    return true;
  }
  isShowDeliveredAnd(){
    if(!this.isShowTotal()){ return false; }
    if(this.isShowStrings()){ return true; }
    return false;
  }
  isShowStrings(){
    return this.opts.strings.length > 0
  }

  isShowMemoTotalBefore(){
    if(this.opts.memo_total_before > 0){ return true; }
    if(this.isShowMemoStringsBefore()){ return false; }
    return true;
  }
  isShowMemoAndBefore(){
    if(!this.isShowMemoTotalBefore()){ return false; }
    if(this.isShowMemoStringsBefore()){ return true; }
    return false;
  }
  isShowMemoStringsBefore(){
    return this.opts.memo_strings_before.length > 0
  }

  isShowMemoTotal(){
    if(this.opts.memo_total > 0){ return true; }
    if(this.isShowMemoStrings()){ return false; }
    return true;
  }
  isShowMemoAnd(){
    if(!this.isShowMemoTotal()){ return false; }
    if(this.isShowMemoStrings()){ return true; }
    return false;
  }
  isShowMemoStrings(){
    return this.opts.memo_strings.length > 0
  }
}
riot.mixin('tasks.delivered-total', DeliveredTotal as riot.TagMixin)
